export default "__VITE_ASSET__ipoiJL3D__"